// shared humanized labels for vehicle wash/maint statuses. chips, edit
// selects, and history rows across the ops surfaces must agree on these.
// acronyms (PM, OOS, DVIR) stay uppercase by design; everything else is
// sentence case. which statuses a given surface OFFERS stays a per-surface
// decision (the board includes OOS, the vsm select trims by washed_enabled);
// only the label text is shared.

const ACRONYMS = ['PM', 'OOS', 'DVIR']

export const VEHICLE_STATUS_LABELS = {
    READY: 'Ready',
    CLEANED: 'Clean',
    WASHED: 'Washed',
    DIRTY: 'Dirty',
    OUT: 'Out',
    OOS: 'OOS',
    PM: 'PM',
    PENDING_DVIR: 'Pending DVIR',
    UNSAFE_DVIR: 'Unsafe DVIR',
}

// fallback for values outside the map: underscores to spaces, sentence
// case per word, acronyms preserved
export const statusLabel = value => {
    if (!value) return ''
    const known = VEHICLE_STATUS_LABELS[value]
    if (known) return known
    return String(value)
        .split(/[_\s]+/)
        .map(w => ACRONYMS.includes(w.toUpperCase())
            ? w.toUpperCase()
            : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(' ')
}

// b-form-select options for a list of status values
export const statusOptions = values => values.map(v => ({ value: v, text: statusLabel(v) }))
